import { MENU, SUBMENU, base_url } from "../../constants";
import { pathPDF } from "../../routes/endpoints";

export const patternUrl = /^((http|https|ftp):\/\/)/;

export const getNavControl = (index: number) => {
    const num = index + 1;
    if (num.toString().length === 1) return `0${num}`;
    return num;
};

export const dinamicResponsiveClass = (i: number) => {
    const classNumber = ((i - 1) % 5) + 1; // El patrón se repite cada 5 elementos, sumamos 1 para tener 1, 2, 3, 4, 5
    return `responsive-nav0${classNumber + 1}`;
};

export const getMenuControl = (title: string) => title?.split(" ").join("");

type alignClassType = "menu" | "submenu";

export const alignDinamicClass = (index: number, type: alignClassType): string => {
    if (index % 5 === 1 && type === MENU) return "";
    if ((index % 5 === 2 || index % 5 === 3) && type === MENU) return "body-center-principal"; // "body-center-principal" para 2, 3, 7, 8, 12, 13, ...
    if (index % 5 === 1 && type === SUBMENU) return "card-body-right"; // "card-body-right" para 1, 6, 11, 16, ... 

    return type === MENU ? "body-center-principal2" : "card-body2"; // "card-body2" para 2, 3, 4, 5, 7, 8, 9, 10, 12, 13, 14, 15, ...
};

export const handleOpenPage = (
    e: React.MouseEvent<HTMLAnchorElement>,
    url: string,
    pdf: string
) => {
    e.preventDefault();
    if (url)
        return patternUrl.test(url)
            ? window.open(url, "_blank")
            : window.open(`/${base_url}${url}`, "_self");
    if (pdf) return window.open(`${pathPDF}${pdf}`);
    return "";
};